

































import { defineComponent, PropType } from "@vue/composition-api"
import { SelectedCoupon } from "../../store/apple-gift-card/state"
import { BuyColumn } from "../../config"

export default defineComponent({
  name: "RechargeBtn",
  props: {
    item: {
      type: Object as PropType<BuyColumn>,
      required: true
    },
    selectedCoupon: {
      type: Object as PropType<SelectedCoupon | null>
    },
    click: {
      type: Function as PropType<() => void>
    },
    buttonClass: {
      type: String,
      required: false
    },
    // 可选的tips文本
    discountText: {
      type: String,
      required: false
    }
  }
})
